import { isEmpty } from 'lodash'
import { getCookie } from './cookie'

export default () => !isEmpty(getCookie('aupd_token'))
